module.exports = __webpack_public_path__ + "img/irrigation-control-4.758330e3.webp";